import createActivityTimer from 'jump-common/timers/createActivityTimer'
import Jump from './Jump'

const jump = new Jump({ createActivityTimer })

if (typeof window !== 'undefined') window.jump = jump

export default jump



// WEBPACK FOOTER //
// ./src/index.js